<script>
import { h,withDirectives  } from 'vue'
import DateTimeUtils from '@/utils/DateTimeUtils'
import { VChip, VTooltip, VDialog, VCard, VCardText, VCardActions, VBtn, VSpacer } from 'vuetify/components'
import MediaViewer from '@/components/base/molecules/MediaViewer/MediaViewer.vue'
import {DataWrapArray} from '@/components/autoImport/BaseDefinition'
import moment from 'moment'

export default {
  filters: {
    formatDate (value) {
      if (!value) return ''
      return moment(value).format('YYYY/MM/DD (dd)')
    },
    formatRelativeDate (value) {
      if (!value) return ''
      return DateTimeUtils.relativeTimeDisplay(value)
    }
  },
  props: {
    type: {
      type: String,
      default: 'default',
      validator: function (value) {
        if ([
          ...DataWrapArray,
          'default',
          'custom'
        ].indexOf(value) !== -1) {
          return true
        } else {
          console.error(`DataWarp type: ${value} is not supported`)
          return false
        }
      }
    }
  },
  methods: {
    formatDate: function (value) {
      if (!value) return ''
      return DateTimeUtils.dateTimeDisplayHK(value)
    },
    formatRelativeDate: function (value) {
      if (!value) return ''
      return DateTimeUtils.relativeTimeDisplay(value)
    }
  },
  render () {
    const context = this
    const value = context.$attrs.value
    // attrs for dynamic comps
    const attrs = context.$attrs.attrs
    let items = context.$attrs.items
    const config = context.$attrs.config || {
      nullValue: '-',
    }

    if (value === undefined) return h('div', config.nullValue)

    if (value === null) return h('div', config.nullValue)

    switch (context.type) {
      case 'default':
        return h('div', { style: { color: 'black' } }, value)
      case 'email': {
        const mailtoHref = `mailto:${value}`
        return h('a', { href: mailtoHref }, value)
      }
      // ISSUE_MEDIUM: No use on LETS
      // case 'longtext': {
      //   const minLongTextLength = 20
      //   const isLongText = value.length > minLongTextLength
      //   const dialog = h(VDialog, {
      //     ref: 'dialog',
      //     props: {
      //       width: 500,
      //       minWidth: 400,
      //       maxWidth: 600
      //     },
      //     scopedSlots: {
      //       activator: function (d) {
      //         const _on = d.on
      //         const _attrs = d.attrs
      //         return h('div', {
      //           class: 'canHover',
      //           attrs: _attrs,
      //           on: _on
      //         }, isLongText ? `${value.substring(0, minLongTextLength)}...` : value)
      //       }
      //     }
      //   }, [
      //     h(VCard, {
      //       class: 'pa-3',
      //       style: {
      //         overflowY: 'auto',
      //         whiteSpace: 'pre-wrap'
      //       }
      //     }, [
      //       h(VCardText, [value]), h(VCardActions, [
      //         h(VSpacer),
      //         h(VBtn, {
      //           props: { color: 'primary', variant: 'outlined' },
      //           on: { click: () => { context.$refs.dialog.isActive = false } }
      //         }, [context.$t('common.close')])
      //       ])
      //     ])
      //   ])
      //   return h('div', { style: { color: 'black' } }, [isLongText ? dialog : value])
      // }
      case 'date': {
        const formattedDate = context.$options.filters.formatDate(value)
        return h('div', { style: { color: 'black' } }, formattedDate)
      }
      case 'relativeDate': {
        return withDirectives(h('div', {
          class: 'canHover',
          style: { cursor: 'pointer' },
        }, context.$options.filters.formatRelativeDate(value)), [
          // v-tooltip directive // wont work
          // [VTooltip, {
          //   content: context.$options.filters.formatDate(value),
          //   location: 'top',
          // }]
        ]
      )
      }
      case 'url':
        return h('a', { href: value, target: '_blank', ...attrs }, value)
      case 'chip': {
        if (Array.isArray(items)) {
          const newItems = {}
          items.forEach((item) => {
            newItems[item.value] = item
          })
          items = newItems
        }
        if (items[value] === undefined) {
          console.error(`DataWarp chip: ${value} is undefined`)
          return h('div', '-')
        }
        const chipColor = items[value].color ?? 'grey'
        const chipLabel = items[value].label ?? items[value].text ?? value
        return h(VChip, { color: chipColor, size: 'small', ...attrs, style: { color: 'white' } }, chipLabel)
      }
      case 'select': {
        if (Array.isArray(items)) {
          const newItems = {}
          items.forEach((item) => {
            newItems[item.value] = item
          })
          items = newItems
        }
        if (items[value] === undefined) {
          console.error(`DataWarp select: ${value} is undefined`)
          return h('div', config.nullValue)
        }
        return h('div', items[value].label ?? items[value].text ?? value)
      }
      // ISSUE_MEDIUM: No use on LETS
      // case 'files':
      //   if (!Array.isArray(value)) { console.error('DataWarp: value is not array'); return h('div', value) }
      //   if (value.length === 0) { return h('div', '-') }
      //   return h(MediaViewer, { value })
      // case 'image': {
      //   let targetVal = {}
      //   if (Array.isArray(value)) {
      //     if (value.length === 0) { console.error('DataWarp: value is empty array'); return h('div', value) }
      //     targetVal = value[0]
      //   } else {
      //     targetVal = value
      //   }
      //   if (typeof targetVal !== 'object') { console.error('DataWarp: value is not object'); return h('div', value) }
      //   return h('img', { src: targetVal.src, alt: context.$attrs.label, contain: true, ...attrs })
      // }
      case 'custom':
        return h(context.$attrs.component, { value, ...attrs })
      case 'text':
        return h('div', value)
      default:
        console.error('DataWarp: Unknown type', context.type)
        return h('div', value)
    }
  }
}
</script>

<style>
.canHover:hover {
  color: grey;
  text-decoration: underline;
  width: fit-content;
}
</style>
